import React from 'react'
import WeatherApp from './components/Weather/WeatherApp'


const App = () => {
  return <>

    <WeatherApp />
  </>
}

export default App